<template>
  <table
    class="min-w-full table-fixed divide-y divide-gray-200 border border-gray-300 rounded-md overflow-hidden text-sm"
  >
    <tbody class="divide-y divide-gray-200">
      <tr
        v-for="(attachment, index) in itemDataDetails.AttachmentFiles"
        :key="index"
        class="odd:bg-white even:bg-gray-50"
      >
        <td class="px-4 py-2 font-semibold w-1/4" v-if="attachment.isdocument">
          <div class="flex items-center justify-between">
            <div class="flex gap-3 items-center">
              <span class="truncate">{{ attachment.particular }} </span>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { inject } from "vue";
export default {
  props: {
    itemDataDetails: Object,
  },
  setup() {
    const axios = inject("$axios");
    const getIconPath = (file) => {
      if (file) {
        let extension = file.split(".").pop();
        let imageExtension = ["png", "jpeg", "jpg"];
        let wordExtension = ["docx"];
        let excelExtension = ["xls", "xlsx", "csv"];
        let zipExtension = ["zip"];

        if (imageExtension.includes(extension)) {
          return require(`@/assets/icons/image.png`);
        } else if (wordExtension.includes(extension)) {
          return require(`@/assets/icons/word.png`);
        } else if (excelExtension.includes(extension)) {
          return require(`@/assets/icons/excel.png`);
        } else if (zipExtension.includes(extension)) {
          return require(`@/assets/icons/zip.png`);
        } else {
          return require(`@/assets/icons/text.png`);
        }
      }
    };

    const downloadFile = async (filename) => {
      const downloadUrl = `/portal/application/reimbursement/attachment?filename=${filename}`;
      try {
        const response = await axios.get(downloadUrl);
        const url = response.request.responseURL;
        window.open(url, "_blank");
      } catch (error) {
        console.error(
          "There has been a problem with your download operation:",
          error
        );
      }
    };
    return {
      getIconPath,
      downloadFile,
    };
  },
};
</script>
